import Api from "@/services/api";
// state
const state = () => ({
  ncms: [],
  ncmsOptions: [],
  mensagemNotificacao: false,
  arNcmSelecionados: [],
  temporaryArNcmSelecionados: []
});

// getters
const getters = {
  getNcms: state => {
    return state.ncms;
  },
  getNcmsOptions: state => {
    return state.ncmsOptions;
  },
  getContador: state => {
    // return state.arNcmSelecionados.filter(
    //   f =>
    //     f.alterado == 0 &&
    //     f.id_usuario &&
    //     // f.vigente == 1 &&
    //     (typeof f.pai == "undefined" || f.pai == false) &&
    //     (typeof f.filho == "undefined" || f.filho == 0) &&
    //     (typeof f.exTipi == "undefined" || f.exTipi.length == 0 || f.exTipi == null)
    // ).length;
    return state.arNcmSelecionados.length;
  },
  getMensagemNotificacao: state => {
    return state.mensagemNotificacao;
  },
  getArNcmSelecionados: state => {
    return state.arNcmSelecionados;
  },
  getTemporaryArNcmSelecionados: state => {
    return state.temporaryArNcmSelecionados;
  }
};

// mutations
const mutations = {
  setNcms(state, ncms) {
    state.ncms = ncms;
  },
  setMensagemNotificacao(state, mensagemNotificacao) {
    state.mensagemNotificacao = mensagemNotificacao;
  },
  SET_NCMS_OPTIONS(state, ncmsOptions) {
    state.ncmsOptions = ncmsOptions;
  },
  SET_AR_NCM_SELECIONADOS(state, arNcmSelecionados) {
    state.arNcmSelecionados = arNcmSelecionados;
  },
  SET_TEMPORARY_AR_NCM_SELECIONADOS(state, temporaryArNcmSelecionados) {
    state.temporaryArNcmSelecionados = temporaryArNcmSelecionados;
  }
};

// actions
const actions = {
  setNcms({ commit }, ncms) {
    commit("setNcms", ncms);
  },
  setNcmsOptions({ commit }, ncmsOptions) {
    commit("SET_NCMS_OPTIONS", ncmsOptions);
  },
  setMensagemNotificacao({ commit }, mensagemNotificacao) {
    commit("setMensagemNotificacao", mensagemNotificacao);
  },
  setArNcmSelecionados({ commit }, arNcmSelecionados) {
    commit("SET_AR_NCM_SELECIONADOS", arNcmSelecionados);
  },
  async fetchArNcmSelecionados(context) {
    const usuarioPro = context.rootGetters["auth/getUsuarioPro"];
    if (usuarioPro) {
      let array = context.state.arNcmSelecionados.reverse();
      array.forEach((e, i) => {
        e.numeracao = i + 1;
      });
      context.commit("SET_AR_NCM_SELECIONADOS", array.reverse());
      return;
    }
    const usuario = context.rootGetters["login/getUser"];
    let arNcmSelecionados = await new Api().get(`NcmSelecionada/${btoa(usuario.id_usuario)}`);
    await arNcmSelecionados.dados.forEach((e, i) => {
      // let valor = `${i + 1}`;
      // e.numeracao = valor.length == 1 ? `00${valor}` : valor.length == 2 ? `0${valor}` : valor;
      e.numeracao = i + 1;
      e.descricao = e.descricao.startsWith("-- ")
        ? e.descricao.slice(3)
        : e.descricao.startsWith("- ") || e.descricao.startsWith("--")
        ? e.descricao.slice(2)
        : e.descricao;
    });
    context.commit("SET_AR_NCM_SELECIONADOS", arNcmSelecionados.dados.reverse());
  },
  async salvarNcm(context, ncm) {
    const usuarioPro = context.rootGetters["auth/getUsuarioPro"];
    if (usuarioPro) {
      let array = context.state.arNcmSelecionados;
      array.unshift({ ...ncm });
      context.commit("SET_AR_NCM_SELECIONADOS", array);
      await context.dispatch("fetchArNcmSelecionados");
    } else {
      await new Api().post("NcmSelecionada/salvar", ncm);
      await context.dispatch("fetchArNcmSelecionados");
    }
  },
  async deleteNcm(context, idNcm) {
    const usuarioPro = context.rootGetters["auth/getUsuarioPro"];
    if (usuarioPro) {
      let array = context.state.arNcmSelecionados;
      let index = array.findIndex(id => id.id == idNcm);
      array.splice(index, 1);
      await context.dispatch("fetchArNcmSelecionados");
    } else {
      await new Api().delete(`NcmSelecionada/remover/${idNcm}`);
      await context.dispatch("fetchArNcmSelecionados");
    }
  },
  async limparListaNcm(context) {
    const usuarioPro = context.rootGetters["auth/getUsuarioPro"];
    if (usuarioPro) {
      context.commit("SET_AR_NCM_SELECIONADOS", []);
    } else {
      await new Api().delete("NcmSelecionada/removerTodasNcms");
      await context.dispatch("fetchArNcmSelecionados");
    }
  },
  setTemporaryArNcmSelecionados({ commit }, temporaryArNcmSelecionados) {
    commit("SET_TEMPORARY_AR_NCM_SELECIONADOS", temporaryArNcmSelecionados);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
